import React from 'react';
import { ProjectData, ContainerP, ContainerUl, ContainerEnlaces, ProjectImg, Project } from '../styles';
import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";

const Work = ({proyecto, tech}) => {
    return ( 
        <Project>
            <ProjectData className="data">
                <h4>Project {proyecto.id}</h4>
                <h5><a 
                    rel="noopener noreferrer" 
                    href={proyecto.site}
                    target="_blank"
                >{proyecto.nombre}</a></h5>
                <ContainerP>
                    <p>{proyecto.descripcion}</p>
                </ContainerP>
                <ContainerUl>
                    {tech.map(tech => (
                        <li key={tech.id}>{tech.nombre}</li>
                    ))}
                </ContainerUl>
                <ContainerEnlaces className="enlaces">
                    {
                        proyecto.repositore ? (
                            <a 
                                rel="noopener noreferrer"
                                target="_blank"
                                href={proyecto.repositore}
                            ><FaGithub /></a>
                        ) : null
                    }
                    <a 
                        rel="noopener noreferrer" 
                        target="_blank"
                        href={proyecto.site}
                    ><FaExternalLinkAlt /></a>
                </ContainerEnlaces>
            </ProjectData>
            
            <ProjectImg
                rel="noopener noreferrer" 
                target="_blank"
                href={proyecto.site} 
                className="project-img"
            >
                <img src={proyecto.img} alt=""/>
            </ProjectImg>
        </Project>
     );
}
 
export default Work;